export function applySortableOrder<T>(
  items: readonly T[],
  orderedIds: readonly string[],
  getId: (item: T) => string,
): T[] {
  const byId = new Map<string, T>();
  for (const item of items ?? []) {
    byId.set(getId(item), item);
  }

  const out: T[] = [];
  const used = new Set<string>();

  for (const id of orderedIds ?? []) {
    if (used.has(id)) continue;
    const item = byId.get(id);
    if (!item) continue;
    used.add(id);
    out.push(item);
  }

  for (const item of items ?? []) {
    const id = getId(item);
    if (used.has(id)) continue;
    used.add(id);
    out.push(item);
  }

  return out;
}

